module.exports = __webpack_public_path__ + "img/thai-express-menu.51dafcd1.webp";